import { BanchatConfigInput, BanchatConfigStatus, configApi } from "../api/ConfigApi";
import {
  AISettings,
  AllConfigDataModel,
  ProductSyncResult,
  WSSettings,
} from "../models/Config/ConfigModel";

class ConfigManager {
  private static instance: ConfigManager;

  public static get(): ConfigManager {
    if (!this.instance) {
      this.instance = new ConfigManager();
    }
    return this.instance;
  }

  async getAllConfig(): Promise<AllConfigDataModel | undefined> {
    try {
      const result = await configApi.allConfigInfo.request(null);
      return result.data;
    } catch (error) {
      console.error("Error en getAllConfig:", error);
      return undefined;
    }
  }

  async updateConfigInfo(
    settings: AISettings | WSSettings
  ): Promise<AllConfigDataModel | undefined> {
    try {
      const result = await configApi.updateConfigInfo.request({
        settings,
      });
      return result.data;
    } catch (error) {
      console.error("Error en updateConfigInfo:", error);
      return undefined;
    }
  }

  async syncProducts(): Promise<ProductSyncResult | undefined> {
    try {
      const result = await configApi.syncProducts.request(null);
      return result.isSuccess ? result.data : undefined;
    } catch (error) {
      console.error("Error en syncProducts:", error);
      return undefined;
    }
  }

  async getBanchatConfig(): Promise<BanchatConfigStatus | undefined> {
    try {
      return (await configApi.getBanchatConfig.request(null)).data;
    } catch (error) {
      console.error("Error consultando la conexión BanChat:", error);
      return undefined;
    }
  }

  async saveBanchatConfig(settings: BanchatConfigInput) {
    try {
      const result = await configApi.saveBanchatConfig.requestHard(settings);
      return {
        configured: result.isSuccess && result.data?.configured === true,
        messageError: result.isSuccess ? undefined : result.messageError,
      };
    } catch (error) {
      console.error("Error guardando la conexión BanChat:", error);
      return {
        configured: false,
        messageError:
          error instanceof Error ? error.message : "Error inesperado al guardar.",
      };
    }
  }

  async deleteBanchatConfig() {
    try {
      return (await configApi.deleteBanchatConfig.request(null)).data;
    } catch (error) {
      console.error("Error desconectando BanChat:", error);
      return undefined;
    }
  }
}

export const configManager = ConfigManager.get();
